import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const digitos = (v: string, max: number) => v.replace(/\D/g, "").slice(0, max);
export const soDigitos = (v: string) => v.replace(/\D/g, "");

export function formatCpf(v: string | null | undefined): string {
  if (!v) return "";
  const d = digitos(v, 11);
  if (d.length !== 11) return d;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function formatPhone(v: string | null | undefined): string {
  if (!v) return "";
  const d = digitos(v, 11);
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  if (d.length <= 2) return d ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
}

export function formatCep(v: string | null | undefined): string {
  if (!v) return "";
  const d = digitos(v, 8);
  if (d.length !== 8) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

/** Máscara enquanto digita: formata o que der, senão deixa os dígitos. */
export const mascara = (fmt: (v: string) => string, max: number) => (v: string) => fmt(digitos(v, max)) || digitos(v, max);

// "YYYY-MM-DD" como meia-noite local — `new Date(str)` jogaria pro dia anterior no Brasil.
function parseYmdLocal(ymd: string): Date {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y ?? 0, (m ?? 1) - 1, d ?? 1);
}

export function calcAge(birthDate: Date | string | null | undefined): number | null {
  if (!birthDate) return null;
  // Partes UTC: o Prisma guarda a data em meia-noite UTC.
  const d = new Date(birthDate);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getUTCFullYear();
  const jaFez = today.getMonth() > d.getUTCMonth() || (today.getMonth() === d.getUTCMonth() && today.getDate() >= d.getUTCDate());
  if (!jaFez) age--;
  return age >= 0 ? age : null;
}

export const formatNascimento = (idade: number | null) => (v: string) =>
  v ? `${format(parseYmdLocal(v), "dd/MM/yyyy", { locale: ptBR })}${idade !== null ? ` (${idade} anos)` : ""}` : "";
